/*********************
rendomly number avialable user on current page
***********************/ 
jQuery(function($) {

   var min = 10;
   var max = 300;
   min = Math.ceil(min);
   max = Math.floor(max);
   var  r =  Math.floor(Math.random() * (max - min + 1)) + min;
   var inc = '0' ;

    var mytimeAgo = ['1', '2', '3', '4', '5','10', '-1', '-2', '-3', '-4', '-5'];
 
   var randomlytimeAgo='';
   var currentmytimeAgo='';

  var plus = ['10', '20', '15'];
 
   var randomlytimeAgo='';
   var currentmytimeAgo='';
   
   var range='';
   
    setInterval(function(){  
     
      
      randomlytimeAgo =  Math.floor(Math.random() * mytimeAgo.length); 
      
    
      currentmytimeAgo = mytimeAgo[randomlytimeAgo];
      
      
      r = parseInt(r)+parseInt(currentmytimeAgo) ; 
      
      
     
      if(10 >= r ){
      
         range =  Math.floor(Math.random() * plus.length);  
        
         var final =  plus[range];
        
        r=r+final;
      }
      if(r>300){
      
          range =  Math.floor(Math.random() * plus.length);  
        
         var final =  plus[range];
        
          r=r-final;

      
      }
                 
      jQuery("#dynamic_counter").html(r); 
  
  }, 2000);
  });


/******************
for read more 
******************/

$(function(){
  $('.product-description').readmore({
    collapsedHeight: 200,
    moreLink: '<a href="javascript:" class="more_load">Read More</a>',
    lessLink: '<a href="javascript:" class="more_load">Less</a>'
  });
});


/************************

product thumb script

*************************/

 
 jQuery(function($){
      function normalizeProductPhoto() {
        $('#ProductPhotoImg').removeAttr('width height').css({
          height: 'auto',
          maxWidth: '100%',
          objectFit: 'contain'
        });
      }

      normalizeProductPhoto();
      $('#ProductPhotoImg').on('load', normalizeProductPhoto);
      $('#ProductThumbs').on('click', 'a.product-single__thumbnail', function() {
        window.setTimeout(normalizeProductPhoto, 0);
      });

      if (!$.fn.flexslider) {
        return;
      }

      $('.flexsliderproduct').flexslider({
        animation: "slide",
       slideshow: false, 
		controlNav: false,
        animationLoop: false,
		pauseOnHover:true, 
        itemWidth: 100,
        itemMargin: 10,
        pausePlay: false,
        start: function(slider){
          $('.slider').removeClass('loading');
        }
      });
    });


